import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEditSmall2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"edit-small-2"} maskId="square-filled-radius-0-stroke-1-IconEditSmall2"><path d="M22.2071 5.50008L18.5 1.79297L12 8.29297V12.0001H15.7071L22.2071 5.50008Z" fill="currentColor"/><path d="M3 3.00012H12V4.00012H4V20.0001H20V12.0001H21V21.0001H3V3.00012Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEditSmall2;
